import { Icon } from '@ztechapps/webui.util'
import { useLayoutContext } from '../../../context/LayoutContext'
import { SidenavSize } from '../../../context/LayoutContext'
import { showBackdrop } from '../../../utils/layout'

export const MenuToggler = () => {
  const { state, updateSettings } = useLayoutContext()

  const toggleSideNav = () => {
    if (state.sidenavSize === SidenavSize.Offcanvas) {
      showBackdrop()
    } else {
      updateSettings({
        sidenavSize: state.sidenavSize === SidenavSize.Condensed ? SidenavSize.Default : SidenavSize.Condensed,
      })
    }
  }

  return (
    <button type="button" className="btn btn-primary btn-icon sidenav-toggle-button" onClick={toggleSideNav}>
      <Icon name="bars" />
    </button>
  )
}
